/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AddressViewModel } from './AddressViewModel';
import {
    AddressViewModelFromJSON,
    AddressViewModelFromJSONTyped,
    AddressViewModelToJSON,
} from './AddressViewModel';

/**
 * 
 * @export
 * @interface EmployerViewModel
 */
export interface EmployerViewModel {
    /**
     * 
     * @type {string}
     * @memberof EmployerViewModel
     */
    name?: string;
    /**
     * 
     * @type {AddressViewModel}
     * @memberof EmployerViewModel
     */
    physicalAddress?: AddressViewModel;
}

/**
 * Check if a given object implements the EmployerViewModel interface.
 */
export function instanceOfEmployerViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EmployerViewModelFromJSON(json: any): EmployerViewModel {
    return EmployerViewModelFromJSONTyped(json, false);
}

export function EmployerViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmployerViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'physicalAddress': !exists(json, 'PhysicalAddress') ? undefined : AddressViewModelFromJSON(json['PhysicalAddress']),
    };
}

export function EmployerViewModelToJSON(value?: EmployerViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Name': value.name,
        'PhysicalAddress': AddressViewModelToJSON(value.physicalAddress),
    };
}

